import React, { useEffect, useState, useRef } from "react";
import {
  FaFileExcel,
  FaFileCode,
  FaNetworkWired,
  FaServer,
  FaCogs,
  FaSalesforce,
} from "react-icons/fa";
import MicrosoftFabric from "../../../../assets/microsoftFabric.png";
import CrateDb from "../../../../assets/crateDb.png";
import C4C from "../../../../assets/c4c.png";
import { SiPostgresql, SiMysql } from "react-icons/si";
import Modal from "../../../common/Modal/Modal";
import Spinner from "../../../common/Spinner/Spinner";
import axiosClient from "../../../../api-client/AxiosClient";
import { toast } from "react-toastify";
import { showError } from "../../../common/Utils";
import { useNavigate, useLocation } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa"; // Add this for back arrow icon
import sql from "../../../../assets/sql1.png";


// this array belongs to multiple data sources
const dbFields = [
  {
    name: "server",
    label: "Server",
    type: "text",
    required: false,
  },
  {
    name: "database",
    label: "Database",
    type: "text",
    required: true,
  },
  {
    name: "username",
    label: "User Name",
    type: "text",
    required: true,
  },
  {
    name: "password",
    label: "Password",
    type: "password",
    required: true,
  },
  {
    name: "host",
    label: "Host",
    type: "text",
    required: true,
  },
  {
    name: "port",
    label: "Port",
    type: "number",
    required: false,
  },
  {
    name: "corporationDbName",
    label: "Connection Name",
    type: "text",
    required: true,
  },
  {
    name: "description",
    label: "Description",
    type: "textarea",
    required: false,
  },
];

const fileUploadField = [{ name: "file", label: "Upload File", type: "file" }];

const fieldConfig = {
  json: [{ name: "url", label: "JSON URL", type: "text" }],
  xml: fileUploadField,
  excel_csv: fileUploadField,
  csv: fileUploadField,
  api: [
    { name: "endpoint", label: "API Endpoint", type: "text" },
    { name: "headers", label: "Headers", type: "textarea" },
  ],
  postgresql: dbFields,
  mysql: dbFields,
  sqlserver: dbFields,
  microsoft_fabric: dbFields,
  CrateDb: dbFields,
  sap_hana: dbFields,
  sap_c4c: dbFields,
  salesforce: [
    { name: "consumerKey", label: "Consumer Key", type: "text", required: true },
    { name: "consumerSecret", label: "Consumer Secret", type: "text", required: true },
    { name: "securityToken", label: "Security Token", type: "text", required: true },
    { name: "username", label: "Username", type: "text", required: true },
    { name: "password", label: "Password", type: "password", required: true },
    { name: "CorporationDbName", label: "Connection Name", type: "text", required: true },
  ],
};

const DataSource = () => {
  const location = useLocation();
  const navSelectedCorporation = location.state?.selectedCorporation || null;

  // Get corporation from localStorage
  const getSelectedCorporation = () => {
    const stored = localStorage.getItem("selectedCorporation");
    return stored ? JSON.parse(stored) : null;
  };
  const [search, setSearch] = useState("");
  const [selectedType, setSelectedType] = useState(null);
  const [formData, setFormData] = useState({
    server: "",
    description: "",
    port: "",
    isActive: true,
    corporationDbName: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [corporations, setCorporations] = useState([]);
  const [selectedCorporation, setSelectedCorporation] = useState(() => {
    const stored = getSelectedCorporation();
    return stored
      ? stored.value
      : navSelectedCorporation
      ? navSelectedCorporation.value
      : null;
  });
  const [mappingDBs, setMappingDBs] = useState([]);
  const dataFetched = useRef(false);
  const navigate = useNavigate();

  const handleBack = () => navigate("/data-sources");

  const handleSourceClick = (type) => {

debugger;
    setSelectedType(type);

    // Get corporation from localStorage
    const storedCorporation = getSelectedCorporation();
    const corporationId = storedCorporation ? storedCorporation.value : null;

    // Get the default mapping DB based on selected type
    let defaultMappingDB = { name: "", description: "", isActive: true };

    // Map source types to corresponding mapping DB names
    const typeToDBNameMap = {
      postgresql: "PostgresSQL",
      sqlserver: "MsSql",
      microsoft_fabric: "MsSql",
      CrateDb: "CrateDb",
      sap_hana: "SAP_HANA",
      sap_c4c: "SAP_HANA",
      mysql: "MySql",
    };

    // Find the mapping DB that matches the selected type
    if (mappingDBs.length > 0 && typeToDBNameMap[type]) {
      const matchingDB = mappingDBs.find(
        (db) => db.name === typeToDBNameMap[type] && db.isActive === true
      );

      if (matchingDB) {
        defaultMappingDB = matchingDB;
      }
    }

    // Set form data with defaults from mapping DB
    setFormData({
      server: "",
      database: "",
      username: "",
      password: "",
      host: "",
      port: "",
      corporationDbName: "",
      description: defaultMappingDB.description,
      isActive: defaultMappingDB.isActive,
      mappingDbId: defaultMappingDB.mappingdbId,
      Corporation: corporationId || "", // Use localStorage corporation
    });

    setShowModal(true);
  };

  const isFormValid = () => {
    const fields = fieldConfig[selectedType] || [];
    return fields.every((field) => {
      const value = formData[field.name];
      if (!field.required) return true;

      if (field.type === "file") {
        return value instanceof File;
      }
      return value !== undefined && value !== "" && value !== null;
    });
  };

  const handleInputChange = (e) => {
    const { name, value, files, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
  };

  const handleSubmit = async () => {

debugger;
    if (!selectedType) return;

    // Get corporation from localStorage
    const storedCorporation = getSelectedCorporation();
    const corporationId = storedCorporation ? storedCorporation.value : null;

    if (!corporationId) {
      toast.error("Please select an Organization from the header");
      return;
    }

    try {
      setLoading(true);
      let response;

      switch (selectedType) {
        case "sqlserver":
        case "postgresql":
        case "mysql":
        case "CrateDb":
        case "sap_hana": {
          // ...existing code...
          const payload = {
            corporationId: Number(corporationId),
            database: formData.database || "",
            server: formData.server || "",
            username: formData.username || "",
            password: formData.password || "",
            host: formData.host || "",
            port: formData.port || "",
            description: formData.description || "",
            corporationDbName: formData.corporationDbName || "",
            isActive: formData.isActive,
            mappingDbId: formData.mappingDbId || undefined,
          };
          // ...existing code...
          if (selectedType === "mysql") {
            payload.name = formData.name || "MySQL";
          } else if (selectedType === "CrateDb") {
            payload.name = formData.name || "CrateDb";
          } else if (selectedType === "sap_hana") {
            payload.name = formData.name || "SAP_HANA";
          }
          response = await axiosClient.post(
            "/api/MappingDB/CorpMappingDB",
            payload
          );
          break;
        }
        case "salesforce": {
          const payload = {
            corporationId: Number(corporationId),
            consumerKey: formData.consumerKey || "",
            consumerSecret: formData.consumerSecret || "",
            securityToken: formData.securityToken || "",
            username: formData.username || "",
            password: formData.password || "",
            corporationDbName: formData.CorporationDbName || "",
            isActive: true,
          };
          debugger;
          response = await axiosClient.post(
            "/api/MappingDB/CorpMappingDB",
            payload
          );
          break;
        }
        case "json": {
          response = await axiosClient.post("/api/upload/json", formData);
          break;
        }
        case "xml": {
          const dataToSend = new FormData();
          Object.entries(formData).forEach(([key, value]) => {
            dataToSend.append(key, value);
          });
          response = await axiosClient.post("/api/upload/xml", dataToSend);
          break;
        }
        case "excel_csv": {
          const dataToSend = new FormData();
          Object.entries(formData).forEach(([key, value]) => {
            dataToSend.append(key, value);
          });
          response = await axiosClient.post("/api/upload/excel", dataToSend);
          break;
        }
        default: {
          toast.warning("API not configured for this source.");
          return;
        }
      }

      if (response.status === 200) {
        toast.success("Connection created successfully!");
        setShowModal(false);
      } else {
        throw new Error("No response data received");
      }
    } catch (err) {
      showError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Listen for storage changes from Header component
    const handleStorageChange = (e) => {
      if (e.detail.key === "selectedCorporation") {
        const newCorporation = JSON.parse(e.detail.newValue);
        setSelectedCorporation(newCorporation.value);
      }
    };

    window.addEventListener("customStorageChange", handleStorageChange);

    return () => {
      window.removeEventListener("customStorageChange", handleStorageChange);
    };
  }, []);

  const sourceData = [
    {
      id: "json",
      name: "JSON",
      icon: <FaFileCode size={40} color="#006400" />,
    },
    { id: "xml", name: "XML", icon: <FaFileCode size={40} color="#CC2927" /> },
    {
      id: "excel_csv",
      name: "Excel/CSV",
      icon: <FaFileExcel size={40} color="#217346" />,
    },
    {
      id: "api",
      name: "API",
      icon: <FaNetworkWired size={40} color="#007bff" />,
    },
    {
      id: "postgresql",
      name: "PostgreSQL",
      icon: <SiPostgresql size={40} color="#336791" />,
      mappingDbName: "PostgresSQL",
    },
    {
      id: "mysql",
      name: "MySQL",
      icon: <SiMysql size={40} color="#00758F" />,
      mappingDbName: "MySQL",
    },
    {
      id: "sqlserver",
      name: "SQL Server",
      icon: <img src={sql} alt="CrateDb" style={{ height: "60px" }} />,
      mappingDbName: "MsSql",
    },
    {
      id: "CrateDb",
      name: "Cratedb",
      icon: <img src={CrateDb} alt="CrateDb" style={{ height: "40px" }} />,
      mappingDbName: "CrateDb",
    },
    {
      id: "sap_hana",
      name: "SAP HANA",
      icon: <FaCogs size={40} color="#008FD3" />,
      mappingDbName: "SAP_HANA",
    },
    {
      id: "salesforce",
      name: "Salesforce",
      icon: <FaSalesforce size={40} color="#007bff" />,
    },
    {
      id: "microsoft_fabric",
      name: "MS Fabric",
      icon: <img src={MicrosoftFabric} alt="Microsoft Fabric" style={{ height: "40px" }} />,
      mappingDbName: "PostgresSQL",
    },
    {
      id: "sap_c4c",
      name: "SAP C4C",
      icon: <img src={C4C} alt="C4C SAP" style={{ height: "40px" }} />,
      mappingDbName: "SAP_HANA",
    },
    
  ];

  // Modified approach: show all database sources
  const filteredSources = sourceData.filter((source) => {
    return source.name.toLowerCase().includes(search.toLowerCase());
  });

  useEffect(() => {
    const fetchData = async () => {
      if (dataFetched.current) return; // Prevent multiple fetches

      setLoading(true);
      dataFetched.current = true;

      try {
        // Fetch corporations data
        const corpResponse = await axiosClient.get(
          "/api/Corporation/GetUserCorporations"
        );
        if (corpResponse?.data) {
          const distinctCorporations = Array.from(
            new Map(
              corpResponse.data.map((item) => [item.corporationId, item])
            ).values()
          );
          setCorporations(distinctCorporations);

          // Set corporation from localStorage instead of auto-selecting
          const storedCorporation = getSelectedCorporation();
          if (storedCorporation) {
            setSelectedCorporation(storedCorporation.value);
          }
        }

        // Fetch mapping DB data
        const mappingResponse = await axiosClient.get("/api/MappingDB");
        if (mappingResponse?.data) {
          setMappingDBs(mappingResponse.data);
        }
      } catch (error) {
        showError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="import-container">
      {loading && <Spinner />}
      {/* <h2>Import Data</h2> */}

      <div className="flex items-center justify-between mb-4">
        <h2 className="text-2xl font-bold text-gray-900">Add Data Source</h2>
        <button
          onClick={handleBack}
          className="flex items-center text-blue-600 hover:text-blue-800 p-2 rounded hover:bg-blue-50 transition-colors"
          title="Go back"
        >
          <FaArrowLeft className="mr-2" />
          Back
        </button>
      </div>

      <div className="search-box">
        <input
          type="text"
          placeholder="Search for sources"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="data-sources">
        {filteredSources.map((source) => (
          <div
            key={source.id}
            className="source-card"
            onClick={() => handleSourceClick(source.id)}
          >
            {source.icon}
            <p>{source.name}</p>
          </div>
        ))}
      </div>

      <Modal
        show={showModal}
        title={`Configure ${selectedType?.toUpperCase()} Source`}
        setShowModal={setShowModal}
      >
        {fieldConfig[selectedType]?.map((field) => {
          // Ensure the connection name field is always visible, unlike name/description
          if (
            (field.name === "name" || field.name === "description") &&
            selectedType &&
            sourceData.find((s) => s.id === selectedType)?.mappingDbName
          ) {
            return null;
          }

          return (
            <div key={field.name} className="modal-field">
              <label>
                {field.label}
                {field.required && <span className="text-red-500 ml-1">*</span>}
              </label>
              {field.type === "dropdown" ? (
                <select
                  name={field.name}
                  onChange={handleInputChange}
                  value={formData[field.name] || ""}
                  disabled={corporations.length === 1}
                  className={`form-select ${field.required ? "required" : ""}`}
                  required={field.required}
                >
                  <option value="" disabled>
                    Select {field.label}
                  </option>
                  {corporations.map((corp) => (
                    <option key={corp.corporationId} value={corp.corporationId}>
                      {corp.name}
                    </option>
                  ))}
                </select>
              ) : field.type === "textarea" ? (
                <textarea
                  name={field.name}
                  onChange={handleInputChange}
                  value={formData[field.name] || ""}
                  className={field.required ? "required" : ""}
                  required={field.required}
                  placeholder={
                    field.required
                      ? `Enter ${field.label}`
                      : `Enter ${field.label} (Optional)`
                  }
                />
              ) : (
                <input
                  name={field.name}
                  type={field.type}
                  value={formData[field.name] || ""}
                  onChange={handleInputChange}
                  className={field.required ? "required" : ""}
                  required={field.required}
                  placeholder={
                    field.required
                      ? `Enter ${field.label}`
                      : `Enter ${field.label} (Optional)`
                  }
                />
              )}
            </div>
          );
        })}

        <div className="modal-actions">
          <button className="cancel-btn" onClick={() => setShowModal(false)}>
            Cancel
          </button>
          <button
            className={`submit-btn ${!isFormValid() ? "disabled" : ""}`}
            onClick={handleSubmit}
            disabled={!isFormValid()}
          >
            Submit
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default DataSource;
